import React from 'react';
import './home.scss';
import bgLogin from "../../assets/bgLogin02.jpg";

export default function Home() {

  const bgLoginImg = localStorage.getItem('bg-login-img');
  const appLabel = localStorage.getItem('APP_LABEL');

  return (
    <div className="home-dashboard-wrapper">
      {/* Banner principal con imagen de fondo */}
      <div style={{ 
        position: 'relative',
        height: '100%',
        width: '100%',
        backgroundImage: `url('${bgLoginImg}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        overflow: 'hidden',
        margin: 0,
        padding: 0
      }}>
        {/* Overlay oscuro con gradiente */}
        <div style={{ right: 0, left: 'auto', bottom: '0px', textAlign: 'right', paddingRight: '20px', background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)', width: '100%', position: 'absolute' }}>
          <h1 className="text-end d-flex flex-column align-items-end mb-4 p-5"
          style={{ fontSize: 'clamp(3rem, 5vw, 7rem)', color: 'white' }}>
          <span dangerouslySetInnerHTML={{ __html: appLabel.replace(/\|/g, "<br>") }} />
          </h1>

        </div>
      </div>
    </div>
  );
}
